import $ from "jquery";

window.jQuery = $;
window.$ = $;

const vehicleRegistrations = () => {
    const vehicleRegistrationList = $('#vehicleRegistrations');

    // #addRegistration on click handler
    $('#addRegistration').on('click', (e) => {
        const listItem = `<li class="list-group-item p-0">
                                            <div class="input-group mb-3">
                                                <input 
                                                    type="text" 
                                                    class="form-control" 
                                                    placeholder="Registration Number"
                                                    name="registrations[]"
                                                >
                                                <button 
                                                    class="delete btn btn-danger" 
                                                    type="button"
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </li>`;

        // Append li item to list at bottom
        vehicleRegistrationList.append(listItem);
    });

    // Delete button on click handler
    vehicleRegistrationList.on('click', '.delete', (e) => {
        $(e.target).closest('li').remove();
    });
}

export default vehicleRegistrations();